import { LockCheckIcon } from './LockCheckIcon';

/**
 * author: François Risoud
 * id CA254138-2001-4A37-8D52-E65D608E0E10
 * name lock-check
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-check.svg
 * tags
 * - Lock 
 */
export const EncryptionVerifiedIcon = LockCheckIcon;
export default EncryptionVerifiedIcon